<template>
	<v-card v-can="'communication.read'">
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$email"
				start
			/>
			<translate>Communications</translate>
		</v-card-title>
		<v-card-text>
			<v-row v-can="'communication.create'">
				<v-col class="pb-0">
					<manual-communication
						:recipient-id="recipientId"
						:domain="domain"
						:language="language"
						:order-id="modelName==='order' ? modelId : null"
						:claim-id="modelName==='claim' ? modelId : null"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col
					v-if="communications"
					class="pt-0"
				>
					<model-backend-table
						v-model="communications"
						density="compact"
						:endpoint="communicationsEndpoint"
						:headers="tableHeaders"
						:items-per-page-options="[10, 50, 100]"
					>
						<template #item.subject="{ item }">
							<a :href="`/bo/communications?id=${item.id}`">
								{{ item.subject }}
							</a>
							<div
								v-if="item.attachments.length > 0"
								class="pa-2"
							>
								<v-row
									v-for="(attachment, key) in item.attachments"
									:key="key"
								>
									<v-col class="pa-0">
										<v-icon
											size="small"
											icon="$attachment"
										/>
										<a :href="`/bo/attachments?id=${attachment.id}`">
											{{ attachment.filename }}
										</a>
									</v-col>
								</v-row>
							</div>
						</template>
						<template #item.sentAt="{ item }">
							<span v-if="item.sentAt==='not yet sent'">
								(<translate>{{ item.sentAt }}</translate>)
							</span>
							<span v-else>
								{{ item.sentAt }}
							</span>
						</template>
					</model-backend-table>
				</v-col>
				<v-col
					v-else
					class="pt-0"
				>
					<span>
						{{ $gettext('There is no communication with the customer yet.') }}
					</span>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import ManualCommunication from '../organisms/ManualCommunication.vue';
import {
	axios,
} from '../../services/axios-service';
import {
	displayError,
} from 'laravel-front-library';

export default {
	name: 'CustomerCommunications',
	components: {
		ManualCommunication
	},

	props: {
		modelName: {
			required: true,
			type: String
		},
		modelId: {
			required: true,
			type: Number
		},

		recipientId: {
			required: true,
			type: Number
		},
		language: {
			type: Object,
			required: true,
		},
		domain: {
			type: Object,
			required: true,
		},
		customEndpoint: {
			type: String,
			required: false,
			default: null,
		}
	},

	data () {
		return {
			communications: null,
		};
	},

	computed: {
		tableHeaders () {
			return [
				{
					title: this.$gettext('Topic'), value: 'subject', sortable: false
				},
				{
					title: this.$gettext('Sent'), value: 'sentAt', sortable: false
				},
			];
		},

		communicationsEndpoint () {
			return this.customEndpoint ? this.customEndpoint : `/api/v0/communications?${this.modelName}_id=${this.modelId}`;
		}
	},

	mounted () {
		this.retrieveCommunications();
	},

	methods: {

		/**
		 * Retrieve the communications
		 */
		retrieveCommunications () {
			axios.get(this.communicationsEndpoint)
				.then(({
					data: data
				}) => {
					if (data && data.length > 0) {
						this.communications = data;
					}
				})
				.catch((error) => {
					displayError(this.$gettext('Something has gone wrong during data retrieval'));
					window.captureException(error);
				});
		}
	}
};
</script>
